import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { TrackedLink, TrackedLinkContext } from "@faire/retailer-visitor-shared/components/TrackedLink/index";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import { IClickInfo } from "@faire/web-api--source/indigofair/data/IClickInfo";
import React, { useContext } from "react";
/**
 * Component that understands that MarketplaceProduct should be wrapped in a
 * TrackedLinkContext that provides the context for tracking a product click
 * and derives what a brand click should look like.
 */ export var MarketplaceProductBrandLink = function(props) {
    var context = useContext(TrackedLinkContext);
    var to = props.to, children = props.children, linkProps = _object_without_properties(props, [
        "to",
        "children"
    ]);
    if (!context) {
        if (to === undefined) {
            return /*#__PURE__*/ _jsx(_Fragment, {
                children: children
            });
        }
        return /*#__PURE__*/ _jsx(Link, _object_spread_props(_object_spread({
            to: to
        }, linkProps), {
            children: children
        }));
    }
    return /*#__PURE__*/ _jsx(TrackedLinkContext.Provider, {
        value: {
            type: IClickInfo.Type.BRAND,
            containerName: "".concat(context.containerName, "_brand"),
            requestId: context.requestId || ""
        },
        children: /*#__PURE__*/ _jsx(TrackedLink, _object_spread_props(_object_spread({}, props), {
            children: children
        }))
    });
};
